import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useGetProductContentsQuery } from '../features/api/rest/apiProductContentsSlice';
import Error from './Error';
import BoardResults from './BoardResults';
import Spinner from './Spinner';

function CheckBoard() {
  const { ean } = useParams();
  const { t } = useTranslation();

  const { count, isLoading, isFetching, isError } = useGetProductContentsQuery(
    { ean },
    {
      selectFromResult: ({ data }) => ({
        count: data?.count,
      }),
    }
  );

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  if (count === 0) {
    return <Typography sx={{ mt: 1, fontSize: 18 }}>{t('products.board.no-messages')}.</Typography>;
  }

  return <BoardResults ean={ean} />;
}

export default CheckBoard;
